//your in app text messages go here. This file can be later replaced by external source
const messages = {
  SOMETHING_WENT_WRONG:
    'Something went wrong. Try again after sometime or Please reachout to support team',
  LOADING_NEXT_20_RECORDS: 'Loading next 20 records',
  LOADING_SELECT_COHORT_CHANGES: 'Loading selected cohorts changes',
  COHORT_DETAILS: {
    TITLE: 'Cohort Details',
    SUBTITLE:
      'Select the properties that you would like to apply to current data',
  },
  NO_DATA_CONTENT: "You don't have access to any of the users",
  NO_DATA_DRUGS: 'We do not see drug usage in this category',
  NO_AGGREGATE_DATA: ' This group does not have aggregate stop loss coverage',
};

export default messages;
